import { render, staticRenderFns } from "./bookRecardReportList.vue?vue&type=template&id=a5cc2884"
import script from "./bookRecardReportList.vue?vue&type=script&lang=js"
export * from "./bookRecardReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports